import styles from "./noDataStyles.js";
import { Container, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const NoData = ({ title = 'No se encontraron resultados' }) => (
  <Container sx={styles.noDataContainer}>
    <SearchOffIcon sx={styles.noDataIcon} />
    <Typography sx={styles.noDataTitle}>{title}</Typography>
  </Container>
);

export default NoData;